import { DATE_MASK_PLACEHOLDER } from '../../../constants/date'

export const DATE_INPUT_FORMAT_HINT = DATE_MASK_PLACEHOLDER

export const DATE_INPUT_FORMAT_MAX_LENGTH = 10
